export const SET_RUNNING = "SET_RUNNING";
export const SET_VOLUME = "SET_VOLUME";

export const INCREMENT_TEMPO = "INCREMENT_TEMPO";
export const DECREMENT_TEMPO = "DECREMENT_TEMPO";
export const SET_TEMPO = "SET_TEMPO";

export const INCREMENT_SCALE = "INCREMENT_SCALE";
export const DECREMENT_SCALE = "DECREMENT_SCALE";
export const SET_SCALE = "SET_SCALE";
export const SET_NOTATION = "SET_NOTATION";

export const SET_CLEF = "SET_CLEF";
export const SET_TIME = "SET_TIME";
export const SET_INSTRUMENT = "SET_INSTRUMENT";
